import { defineComponent as _defineComponent } from 'vue'
import { Icons } from '@/icons/icons'
import useActionsAlertsMessages from '@/components/Navigation/AppBarToolbarItems/contextMenus/composables/useActionsAlertsMessages'
import { ListStatus } from '@/store/modules/alertsMessages/alertsMessagesTypes'
import AlertsListComponent from './AlertsListComponent.vue'
import SpinnerLayerComponent from '@/components/Spinner/SpinnerLayerComponent.vue'

// DATA

export default /*#__PURE__*/_defineComponent({
  __name: 'AlertsContextMenuComponent',
  setup(__props) {

const iconAlerts = Icons.ALERT

// COMPOSABLES
const { status, loadAlertsMessagesList, userHasAlerts } = useActionsAlertsMessages()

// EVENTS
const onClick = async () => {
  await loadAlertsMessagesList()
}


return { __sfc: true,iconAlerts, status, loadAlertsMessagesList, userHasAlerts, onClick, ListStatus, AlertsListComponent, SpinnerLayerComponent }
}

})